import { Container, interfaces } from 'inversify'

export const container = new Container()

export function registerPerRequestService<T>(
  containerInstance: interfaces.Container,
  type: symbol,
  constructor: new (...args: never[]) => T
): void {
  if (containerInstance.isBound(type)) {
    containerInstance.unbind(type)
  }
  containerInstance.bind<T>(type).to(constructor).inSingletonScope()
}

export function registerPerRequestServiceToConstantValue<T>(
  containerInstance: interfaces.Container,
  type: symbol,
  value: T
): void {
  if (containerInstance.isBound(type)) {
    containerInstance.unbind(type)
  }
  containerInstance.bind<T>(type).toConstantValue(value)
}

//  DON'T DELETE - used by DW
